import { Component, Inject } from "@angular/core";
import { COContact } from "@tylertech/tyler-api-types";
import { MAT_DIALOG_DATA, MatDialogRef } from "@angular/material/dialog";
import { CommonDialogsService } from "@tylertech/common-dialogs-module";
import { FormGroup } from "@angular/forms";
export interface ContactManagerDialogData
{
    readonly contact: COContact;
}
@Component({
    selector: "contact-manager-dialog-component",
    templateUrl: "./contactManagerDialog.tmpl.html",
    standalone: false
})
export class ContactManagerDialogComponent
{
    readonly contactDialogForm: FormGroup;
    childViewShown: boolean;

    constructor(
        private readonly dialogRef: MatDialogRef<ContactManagerDialogComponent, COContact | undefined>,
        @Inject(MAT_DIALOG_DATA) private readonly data: ContactManagerDialogData,
        private readonly commonDialogsService: CommonDialogsService)
    {
        this.contactDialogForm = new FormGroup({});
    }

    get contact(): COContact
    {
        return this.data.contact;
    }

    cancelClicked(): void
    {
        this.dialogRef.close();
    }

    doneClicked(): void
    {
        if (this.contactDialogForm.invalid)
        {
            // if (Object.entries(this.contactDialogForm.errors)
            //     .find())
            // {
            //     this.commonDialogsService.showAlertHtmlMessage(
            //         "There is invalid data in the User Defined Fields.", "UDD Errors", "Error");
            // }
            return;
        }

        if (this.contact.IsIndividual && !this.hasFullName())
        {
            return;
        }

        // ! TODO: Review Dialog Conversion; call expression was 'this.$mdDialog.hide(this.contact).'
        this.dialogRef.close(this.contact);
    }

    onViewChanged($event: Record<"isChildView", boolean>): void
    {
        this.childViewShown = $event.isChildView;
    }

    private hasFullName(): boolean
    {
        if (!this.contact.FirstName || !this.contact.LastName)
        {
            this.commonDialogsService.showAlertMessage(
                "Contacts who are individuals require a first and last name.",
                "Full Name is Required");
            return false;
        }
        return true;
    }
}
